/** Origin for template → editor → campaign design flow (Use template). */
export const TEMPLATE_DESIGN_FLOW_ORIGIN = {
    CAMPAIGN_SELECTOR: 'campaign-selector',
    TEMPLATES_LIST: 'templates-list',
};
